import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useAction } from 'hooks';
import Close from 'svg/x.svg';
import * as actions from '../../../../actions';
import { getLabel, getTooltipComponent } from './utils';
import Nav from './Nav';
import Dots from './Dots';
import styles from './StackTooltip.pcss';
const StackTooltip = ({ onTooltipClose, data, tooltipType })=>{
    useStyles(styles);
    const setMeasurementElem = useAction(actions.setSelectedReading);
    const [currentIndex, setCurrentIndex] = useState(0);
    const TooltipComponent = getTooltipComponent(tooltipType);
    const navLabel = getLabel(data[currentIndex], tooltipType);
    const onCloseHandler = (e)=>{
        setMeasurementElem(null);
        e.stopPropagation();
        onTooltipClose();
    };
    const onChangeIndexHandler = (newIndex)=>{
        setCurrentIndex(newIndex);
    };
    useEffect(()=>{
        setMeasurementElem(data[currentIndex]);
    }, [
        currentIndex
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.tooltip,
        children: [
            /*#__PURE__*/ _jsx(Close, {
                onClick: onCloseHandler,
                className: styles.tooltip__close
            }),
            /*#__PURE__*/ _jsx(TooltipComponent, {
                element: data[currentIndex]
            }),
            /*#__PURE__*/ _jsx(Dots, {
                currentIndex: currentIndex,
                indexes: Array.from(data.keys())
            }),
            /*#__PURE__*/ _jsx(Nav, {
                onIndexChange: onChangeIndexHandler,
                measurmentsCount: data.length,
                currentIndex: currentIndex,
                label: navLabel
            })
        ]
    });
};
export default /*#__PURE__*/ memo(StackTooltip);
